import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState, fYear } from "../../../components/shared/GlobalState";
import {
  FaUserTie,
  FaCalendarAlt,
  FaDollarSign,
  FaExchangeAlt,
  FaClipboardCheck,
  FaCommentAlt,
} from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoSave } from "react-icons/io5";

const SalaryCreateChild = () => {
  let navigate = useNavigate();
  const inputWidth = "230px";
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  //Error Logging Service & Santize Input
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [financial_year] = useAtom(fYear);
  const [churchMembers, setChurchMembers] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [formData, setFormData] = useState({
    employee_id: null,
    description: null,
    date: dayjs().format("MM-DD-YYYY"),
    amount: null,
    status: null,
    transfer_source: null,
  });

  //   Church Members
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/church/expense/employee/${user?.church_id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      // data: { ...formData },
    };

    axios(config)
      .then(function (response) {
        //console.log(response.data);
        const members = response.data.members;
        console.log(members);
        setChurchMembers(
          members.map((member) => ({
            value: member?._id,
            label:
              member?.first_name +
              " " +
              member?.last_name +
              " (" +
              member?.user_type +
              ")",
          }))
        );
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "ExpenseAddChild", "/expense/add");
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleAddExpense = (e) => {
    e.preventDefault();
    let userToken = localStorage.getItem("token");
    if (!user?.current_financial_year) {
      toast.error("Please select financial year");
      return;
    }
    const finData = {
      ...formData,
      financial_year: user?.current_financial_year,
    };
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/salary/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: finData,
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        toast.success("Salary Created Successfully.");
        navigate("/salaries");
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "SalaryAddChild", "/salary/add");
        // console.log(error);
      });
  };

  const incomeSourceOptions = [
    { value: 1, label: "Cash" },
    { value: 2, label: "Cheque" },
    { value: 3, label: "Online Transfer" },
    { value: 4, label: "Demand Draft" },
  ];

  const paymentStatusOption = [
    { value: 1, label: "Pending" },
    { value: 2, label: "Settled" },
    { value: 3, label: "Declined" },
  ];
  return (
    <div className="flex justify-center w-full min-h-screen py-8 bg-gray-100">
      <div className="w-full max-w-2xl p-8 bg-white rounded-lg shadow-md">
        <h2 className="mb-6 text-2xl font-semibold text-gray-800">
          Add Salary
        </h2>
        <form onSubmit={(e) => handleAddExpense(e)} autoComplete="off">
          <div className="space-y-6">
            <div className="flex items-center">
              <FaUserTie className="mr-2 text-gray-400" />
              <Select
                name="employee_id"
                onChange={(selected) => {
                  setFormData({
                    ...formData,
                    employee_id: selected.value,
                  });
                }}
                options={churchMembers}
                placeholder={placeHolderText("Select Member")}
                className="w-full"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#e2e8f0",
                    "&:hover": { borderColor: "#cbd5e0" },
                  }),
                }}
              />
            </div>

            <div className="flex items-center">
              <FaCalendarAlt className="mr-2 text-gray-400" />
              <DatePicker
                className="w-full border-gray-300 rounded-md"
                name="date"
                defaultValue={dayjs()}
                format="MM-DD-YYYY"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    date: dateString,
                  });
                }}
                showToday={true}
              />
            </div>

            <div className="flex items-center">
              <FaDollarSign className="mr-2 text-gray-400" />
              <input
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="amount"
                type="number"
                required
                placeholder="Enter Amount"
                autoComplete="off"
                onChange={handleChange}
              />
            </div>

            <div className="flex items-center">
              <FaExchangeAlt className="mr-2 text-gray-400" />
              <Select
                name="transfer_source"
                onChange={(selected) => {
                  setFormData({
                    ...formData,
                    transfer_source: selected.label,
                  });
                }}
                options={incomeSourceOptions}
                placeholder={placeHolderText("Select Source")}
                className="w-full"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#e2e8f0",
                    "&:hover": { borderColor: "#cbd5e0" },
                  }),
                }}
              />
            </div>

            <div className="flex items-center">
              <FaClipboardCheck className="mr-2 text-gray-400" />
              <Select
                name="status"
                onChange={(selected) => {
                  setFormData({
                    ...formData,
                    status: selected.value,
                  });
                }}
                options={paymentStatusOption}
                placeholder={placeHolderText("Select Status")}
                className="w-full"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#e2e8f0",
                    "&:hover": { borderColor: "#cbd5e0" },
                  }),
                }}
              />
            </div>

            <div className="flex items-start">
              <FaCommentAlt className="mt-3 mr-2 text-gray-400" />
              <textarea
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="description"
                rows={3}
                placeholder="Salary Description (If any)"
                autoComplete="off"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="flex justify-end mt-8 space-x-4">
            <button
              className="flex items-center px-4 py-2 text-gray-600 transition duration-300 bg-gray-200 rounded-md hover:bg-gray-300"
              onClick={() => navigate(-1)}
              type="button"
            >
              <IoMdArrowRoundBack className="mr-2" /> Back
            </button>
            <button
              className="flex items-center px-4 py-2 text-white transition duration-300 bg-blue-600 rounded-md hover:bg-blue-700"
              type="submit"
            >
              <IoSave className="mr-2" /> Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SalaryCreateChild;
